import React, {
  useEffect, useState, Suspense, lazy,
} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './Celebration.scss';
import Logger from '../../utils/logger';
import { getTranslation } from '../../providers/TranslationProvider';

const LottiePlayer = lazy(() => import('lottie-react').then((mod) => ({
  default: mod.default,
})));

const Celebration = ({ close, firstName, ResyAmexConfig }) => {
  const [animationData, setAnimationData] = useState(null);
  const { baseRequestUrl } = ResyAmexConfig;
  let timer;

  const startTimer = () => {
    timer = setTimeout(() => {
      close();
    }, 3000);
  };

  useEffect(() => {
    fetch(`${baseRequestUrl}confetti.json`)
      .then((res) => res.json())
      .then((data) => {
        setAnimationData(data);
      })
      .catch((err) => {
        Logger.error('Failed to load animation:', err);
        startTimer();
      });
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const welcomeMessage = getTranslation({
    translationKey: 'onboarding.welcome_message',
    translationValues: { firstName },
    fallback: `Welcome to Resy, ${firstName}`,
  });

  return (
    <div className="CelebrationContainer">
      <Suspense fallback={<div />}>
        <>
          {animationData?.layers && (
            <div className="celebration-background">
              <LottiePlayer className="lottie-player" loop={false} animationData={animationData} onComplete={close} />
            </div>
          )}
          <div className="welcome-overlay" data-testid="message-container">{welcomeMessage}</div>
        </>
      </Suspense>
    </div>
  );
};

Celebration.displayName = 'Celebration';

Celebration.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
    page: PropTypes.func,
  }).isRequired,
  close: PropTypes.func.isRequired,
  firstName: PropTypes.string,
  ResyAmexConfig: PropTypes.shape({
    baseRequestUrl: PropTypes.string.isRequired,
  }).isRequired,
};

Celebration.defaultProps = {
  firstName: '',
};

export { Celebration as ComponentUnderTest };

const mapStateToProps = ({ user }) => ({
  firstName: user.userData.first_name,
});

export default connect(mapStateToProps)(Celebration);
